import type Community from "@travily/types/pending/models/Community";
import type Family from "@travily/types/pending/models/Family";
import type Individual from "@travily/types/pending/models/Individual";
import type { ProfileAccount } from "./ProfileFrame";

/** Normalizes an individual for the shared profile chrome. */
export function individualProfileAccount(individual: Individual): ProfileAccount {
  return {
    ...individual,
    profile_type: "Individual",
    trips: { current_location: individual.current_trip_location, next_location: individual.next_trip_location },
  };
}

/** Normalizes a family for the shared profile chrome. */
export function familyProfileAccount(family: Family): ProfileAccount {
  return {
    ...family,
    profile_type: "Family",
    trips: { current_location: family.current_trip_location, next_location: family.next_trip_location },
  };
}

/** Normalizes a community for the shared profile chrome. Communities have no trips, so `trips` is omitted. */
export function communityProfileAccount(community: Community): ProfileAccount {
  return { ...community, profile_type: "Community" };
}
